export function PuzzleInfo({
  title,
  brandDescription,
}: {
  title: string;
  brandDescription: string;
}) {
  return (
    <div
      className="arcade__puzzle__info"
    >
      <div className="arcade__puzzle__info--title">{title}</div>
      <p className="arcade__puzzle__info--description">{brandDescription}</p>
    </div>
  );
}
